import type { Severity } from "../api/types.gen.ts";
import { t } from "../i18n/index.ts";
import { Segmented } from "./Segmented.tsx";
import { SEVERITIES, SEVERITY_TONE } from "./styles.ts";

/** A severity, one chosen, in its color. */
export function SeverityPicker(p: { value: Severity; label: string; onValue: (s: Severity) => void; class?: string }) {
  return (
    <Segmented
      label={p.label}
      {...(p.class ? { class: p.class } : {})}
      size="xs"
      value={p.value}
      onValue={p.onValue}
      options={SEVERITIES.map((s) => ({ value: s, label: t(`severity.${s}`), tone: SEVERITY_TONE[s] }))}
    />
  );
}
